import { FeatureCard } from "./FeaturesCard";
export default FeatureCard;
export type { FeatureCardProps } from "./FeaturesCard";